module.exports = __webpack_public_path__ + "static/communication-295d35751157cacca6c58cd01a52e2b3.png";